import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { getLinariaClassName } from '../../../utils/getLinariaClassName';
import { NoStyleButton } from '../helpers/NoStyleButton';
import { Icon } from '../Icon';
type StepperSize = Extract<SizesType, 'sm' | 'lg'>;
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** ID of this component, passed down by the controlling parent component */
  id: string;
  /** The maximum value allowed */
  max?: number;
  /** The minimum value allowed */
  min?: number;
  /** Name of this component, passed down by the controlling parent component */
  name: string;
  /** An onChange callback passed down by the controlling parent component */
  onChange: (value: number) => void;
  /** The value passed down by the controlling parent component */
  value: number;
  /** The size of the component */
  size?: StepperSize;
}
const StepperContainer = /*#__PURE__*/styled('div')({
  name: "StepperContainer",
  class: "s1c52r2h",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => NoStyleButton;
export const StepperButton = /*#__PURE__*/styled(_exp())({
  name: "StepperButton",
  class: "s719ejy",
  propsAsIs: true
});
export const InputElement = /*#__PURE__*/styled('input')({
  name: "InputElement",
  class: "i1wxghta",
  propsAsIs: false
});
const isInRange = (value: number, min: number, max: number) => value >= min && value <= max;
export const Stepper = ({
  dataId,
  id,
  min = 0,
  max = 10,
  name,
  size,
  onChange,
  value,
  className
}: Props) => {
  const removeValue = () => {
    const newValue = value - 1;
    if (isInRange(newValue, min, max)) {
      onChange(newValue);
    }
  };
  const addValue = () => {
    const newValue = value + 1;
    if (isInRange(newValue, min, max)) {
      onChange(newValue);
    }
  };
  return <StepperContainer data-id={dataId} className={className}>
      <StepperButton data-id={`StepperMinus`} disabled={value <= min} onClick={removeValue} className={cx(`--size-${size}`)}>
        <Icon name="Minus" size="md" />
      </StepperButton>

      <InputElement readOnly id={id} name={name} type="text" value={value} className={cx(`${getLinariaClassName(InputElement)}--size-${size}`)} />

      <StepperButton data-id={`StepperPlus`} disabled={value >= max} onClick={addValue} className={cx(`--size-${size}`)}>
        <Icon name="Plus" size="md" />
      </StepperButton>
    </StepperContainer>;
};

require("./Stepper.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Stepper.tsx");